import { takeLatest, put, call } from 'redux-saga/effects';

import { buscarExtratosOfx } from '../../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX,
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_PENDING,
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_SUCCESS,
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE,
} from '@handler';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';

// Constante para chave do sessionStorage específica dos extratos OFX
const CONST_FILTER_EXTRATOS_OFX = 'CONST_FILTER_EXTRATOS_OFX';

function* sagaNewFilterNextPageExtratosOFX(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_PENDING });

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_EXTRATOS_OFX) !== null ?
      JSON.parse(sessionStorage.getItem(CONST_FILTER_EXTRATOS_OFX)) : null;

    if (!filterSaved) {
      yield put({ type: NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE, error: 'Filtro não encontrado' });
      return;
    }

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    let list = yield call(
      buscarExtratosOfx,
      idFazenda,
      newFilter.contaBanco?.id ?? -1,
      datas,
      `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`
    );

    sessionStorage.setItem(CONST_FILTER_EXTRATOS_OFX, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_SUCCESS,
      list: list,
      filter: newFilter
    });
  } catch (error) {
    yield put({
      type: NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE,
      error: error.message
    });
  }
}

export default function* watchNewFilterNextPageExtratosOFX() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX, sagaNewFilterNextPageExtratosOFX);
}